import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  LogoutOutlined,
  PersonOutlined,
  ExpandMoreOutlined,
} from "@mui/icons-material";
import { blue } from "@mui/material/colors";
import logo from "../assets/img/pibs_logo_2.png";
import api from "../services/api";

const TopBar = () => {
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchStudentProfile = async () => {
      try {
        const authToken = sessionStorage.getItem("token");

        if (!authToken) {
          navigate("/auth/login");
          return;
        }

        const response = await api({
          url: `/api/user/student/profile`,
          method: "GET",
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (response.status === 200) {
          setStudentName(response.data.data.full_name || "Student");
        }
      } catch (error) {
        console.log("Error fetching profile:", error);
        setStudentName("Student");
      } finally {
        setLoading(false);
      }
    };

    fetchStudentProfile();
  }, [navigate]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/auth/login");
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <div className="flex justify-between items-center w-full">
      <div className="flex shrink-0 gap-3 items-center">
        <img className="h-8 w-8" src={logo} alt="Logo" />
        <div className="font-sans text-lg font-semibold text-blue-950">
          Student Portal
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* User Profile Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <PersonOutlined sx={{ color: blue[700], fontSize: 18 }} />
            </div>
            {!loading && (
              <>
                <span className="text-sm font-medium text-gray-700 w-14 truncate md:w-auto md:overflow-visible md:whitespace-normal">
                  {studentName}
                </span>
                <ExpandMoreOutlined
                  sx={{
                    color: blue[700],
                    fontSize: 16,
                    transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  }}
                />
              </>
            )}
            {loading && (
              <div className="w-4 h-4 border-2 border-blue-300 border-t-blue-600 rounded-full animate-spin"></div>
            )}
          </button>

          {/* Dropdown Menu */}
          {showDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
              <div className="px-4 py-2 border-b border-gray-100">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {studentName}
                </p>
                <p className="text-xs text-gray-500">Student</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-200"
              >
                <LogoutOutlined sx={{ fontSize: 16 }} />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
